import { cn } from "@dalmatech/ui"

const root = cn(
  "flex w-full md:w-[36.75rem] cursor-pointer items-center gap-3 md:gap-5 rounded-2xl border-2 border-dashed border-neutral-200 bg-white p-5 md:p-6 transition-colors hover:border-primary-500 hover:bg-neutral-50 h-[4.75rem] min-h-[4.75rem] md:h-[88px] md:min-h-[88px]"
)

const icon = cn(
  "flex h-14 w-14 shrink-0 items-center justify-center rounded-xl text-primary-500"
)

const label = cn("flex-1 text-left text-sm md:text-[14px] font-bold text-black")

const plusIcon = cn("h-5 w-5 shrink-0 text-neutral-700")

export { icon, label, plusIcon, root }
